import { IApplicationState } from '../../types/redux';

export const selectOfferNoteStatus = (state: IApplicationState) => state.offersByRealtyOfferId.noteStatus;
